import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/our-office/OurOffice.tsx");
